import * as React from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from '../../../../containers/ApplicationContext';
import { selectOfferId } from '../../../../selectors';
import { fetchNearbyHousesInfo } from '../../../../services/offersHistory/fetchNearbyHousesInfo';
import { TAboutNearbyHousesData } from '../../../../store/offerHistory';

export const useGetAboutNearbyHousesData = () => {
  const context = useApplicationContext();
  const offerId = useSelector(selectOfferId);
  const [data, setData] = React.useState<TAboutNearbyHousesData | null>(null);
  const [error, setError] = React.useState<Error | null>(null);
  const [isFetching, setIsFetching] = React.useState<boolean>(false);

  const load = React.useCallback(async () => {
    try {
      setIsFetching(true);

      const res = await fetchNearbyHousesInfo(context, { offerId });
      setData(res);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setIsFetching(false);
    }
  }, [context, offerId]);

  return { data, load, error, isFetching };
};
